class CustomCountdownDays extends HTMLElement {

  constructor(){
    super();

    this.startNode =
      this.getAttribute(
        "data-start-node"
      );

    this.firstCirculation =
      this.getAttribute(
        "data-first-circulation"
      );

    this.endNode =
      this.getAttribute(
        "data-end-node"
      );

    this.days =
      parseInt(
        this.getAttribute(
          "data-days"
        )
      ) || 0;

    this.timer = null;
  }

  connectedCallback(){
    this.start();
  }

  disconnectedCallback(){
    if(this.timer){
      clearInterval(this.timer);
    }
  }

  start(){

    if(this.timer){
      clearInterval(this.timer);
    }

    const now =
      Date.now();

    const start =
      this.parseDate(
        this.startNode
      );

    const first =
      this.parseDate(
        this.firstCirculation
      );

    const end =
      this.parseDate(
        this.endNode
      );

    if(!start || !end){
      this.hide();
      return;
    }

    const startTime =
      start.getTime();

    const endTime =
      end.getTime();

    // 还没到开始时间
    if(now < startTime){
      this.hide();
      return;
    }

    // 活动结束
    if(now >= endTime){
      this.hide();
      return;
    }

    let targetTime;

    /*
      不再单独判断"是否处于第一次循环阶段"，
      统一以 first 为锚点，按 days 步长往后找
      第一个大于 now 的循环节点。

      当 now < first 时，while 循环体一次都不会
      执行，next 直接等于 first，效果等价于原来
      "第一次循环" 分支，行为不变、逻辑更统一。
    */

    const loopTime =
      this.days *
      24 *
      60 *
      60 *
      1000;

    if(!first || loopTime <= 0){

      targetTime =
        endTime;

    }else{

      let next =
        first.getTime();

      while(
        next <= now
      ){
        next += loopTime;
      }

      targetTime =
        next;
    }

    // 最后一轮
    if(targetTime > endTime){
      targetTime =
        endTime;
    }

    this.update(
      targetTime - now
    );

    this.timer =
      setInterval(()=>{

        const remain =
          targetTime -
          Date.now();

        if(remain <= 0){

          clearInterval(
            this.timer
          );

          this.start();

          return;
        }

        this.update(
          remain
        );

      },1000);
  }

  update(time){

    const t =
      this.getParts(
        time
      );

    this.setText(
      ".days",
      t.days
    );

    this.setText(
      ".hours",
      t.hours
    );

    this.setText(
      ".minutes",
      t.minutes
    );

    this.setText(
      ".seconds",
      t.seconds
    );
  }

  setText(selector,value){

    const el =
      this.querySelector(
        selector
      );

    if(el){
      el.textContent =
        value;
    }
  }

  hide(){

    const box =
      this.closest(
        ".product-time-limit--countdown"
      );

    if(box){
      box.style.display =
        "none";
    }else{
      this.style.display =
        "none";
    }
  }

  parseDate(str){

    if(!str){
      return null;
    }

    const arr =
      str.split("-")
      .map(Number);

    const [
      y,
      m,
      d,
      h = 0,
      min = 0,
      s = 0
    ] = arr;

    return new Date(
      y,
      m - 1,
      d,
      h,
      min,
      s
    );
  }

  getParts(time){

    return {

      days:
      String(
        Math.floor(
          time / 86400000
        )
      ).padStart(2,"0"),

      hours:
      String(
        Math.floor(
          time / 3600000
        ) % 24
      ).padStart(2,"0"),

      minutes:
      String(
        Math.floor(
          time / 60000
        ) % 60
      ).padStart(2,"0"),

      seconds:
      String(
        Math.floor(
          time / 1000
        ) % 60
      ).padStart(2,"0")
    };
  }
}

if(
  !customElements.get(
    "custom-countdown-days"
  )
){
  customElements.define(
    "custom-countdown-days",
    CustomCountdownDays
  );
}